import api from './api';

export const login = async (email: string, password: string) => {
    const response = await api.post('/v1/auth/signin', { email, password });

    localStorage.setItem('access_token', response.data.meta.accessToken);
    localStorage.setItem('refresh_token', response.data.meta.refreshToken);
};

// export const resetPassword = async (email: string, otp: string, newPassword: string) => {
//     const response = await api.post('/password_reset/confirm', { email, otp, new_password: newPassword });
//     return response.data;
// };

// export const register = async (email: string, password: string) => {
//     await api.post('/users/', {email, password});
// };
//
// export const forgotPassword = async (email: string) => {
//     await api.post('/forgot-password', {email});
// };

export const isAuthenticated = () => {
    return !!localStorage.getItem('access_token');
};

export const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
};
